// src/services/cloudFunctions.js
import firebaseApp, { auth } from '../firebaseConfig';

const DEFAULT_REGION = process.env.REACT_APP_FUNCTIONS_REGION || 'southamerica-east1';
const CUSTOM_BASE_URL = process.env.REACT_APP_FUNCTIONS_BASE_URL;
const projectId = firebaseApp?.options?.projectId;
const inferredBaseUrl = projectId
  ? `https://${DEFAULT_REGION}-${projectId}.cloudfunctions.net`
  : '';
const FUNCTIONS_BASE_URL = CUSTOM_BASE_URL || inferredBaseUrl;

const ADMIN_HTTP_PATHS = {
  createUser: 'createAuthUserHttp',
  updateUser: 'updateManagedUserHttp',
  deleteUser: 'deleteAuthUserHttp',
  resetPassword: 'resetAuthUserPasswordHttp',
  completeCompulsoryPasswordChange: 'completeCompulsoryPasswordChangeHttp',
};

const buildUrl = (path) => {
  if (!FUNCTIONS_BASE_URL) {
    throw new Error('Nao foi possivel determinar o endpoint dos Cloud Functions.');
  }
  return `${FUNCTIONS_BASE_URL}/${path}`;
};

const parseResponseBody = async (response) => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

const callProtectedHttpFunction = async (path, payload) => {
  const current = auth.currentUser;
  if (!current) {
    const err = new Error('Usuario nao autenticado.');
    err.code = 'auth/no-current-user';
    throw err;
  }
  const token = await current.getIdToken();
  let response;
  try {
    response = await fetch(buildUrl(path), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload ?? {}),
    });
  } catch (networkError) {
    const err = new Error('Falha ao conectar ao servidor.');
    err.code = 'network/unavailable';
    err.cause = networkError;
    throw err;
  }
  const body = await parseResponseBody(response);
  if (!response.ok) {
    const err = new Error(body?.message || 'A requisicao retornou erro.');
    err.code = body?.code || `http/${response.status}`;
    throw err;
  }
  return body;
};

export const createRemoteAuthUser = (payload) =>
  callProtectedHttpFunction(ADMIN_HTTP_PATHS.createUser, payload);

export const updateRemoteAuthUser = (payload) =>
  callProtectedHttpFunction(ADMIN_HTTP_PATHS.updateUser, payload);

export const deleteRemoteAuthUser = (payload) =>
  callProtectedHttpFunction(ADMIN_HTTP_PATHS.deleteUser, payload);

export const resetRemoteAuthUserPassword = (payload) =>
  callProtectedHttpFunction(ADMIN_HTTP_PATHS.resetPassword, payload);

export const completeCompulsoryPasswordChangeRemote = (payload) =>
  callProtectedHttpFunction(ADMIN_HTTP_PATHS.completeCompulsoryPasswordChange, payload);

export const functionsBaseUrl = FUNCTIONS_BASE_URL;
